import React, { useState, useEffect } from 'react';
import './TeamMembers.css';

const TeamMembers = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const teamMembers = [
    {
      id: 1,
      name: 'K. D. Patil',
      position: 'Idol',
      image: '/assets/img/team/user1.jpg'
    },
    {
      id: 2,
      name: 'Vishal Desale',
      position: 'Founder',
      image: '/assets/img/team/user1.jpg'
    },
    {
      id: 3,
      name: 'Kunal Desale',
      position: 'Finance Manager',
      image: '/assets/img/team/user1.jpg'
    },
    {
      id: 4,
      name: 'Rahul Desale',
      position: 'Senior Engineer',
      image: '/assets/img/team/user1.jpg'
    },
    {
      id: 5,
      name: 'Gautam Bhadarge',
      position: 'Supervisor',
      image: '/assets/img/team/user1.jpg'
    },
    {
      id: 6,
      name: 'Rahul Barve',
      position: 'Engineer',
      image: '/assets/img/team/user1.jpg'
    },
    {
      id: 7,
      name: 'Sharad Sanap',
      position: 'Site Manager',
      image: '/assets/img/team/user1.jpg'
    }
  ];

  const itemsPerView = 4;
  const maxIndex = Math.max(0, teamMembers.length - itemsPerView);

  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => {
          if (prevIndex >= maxIndex) {
            return 0;
          }
          return prevIndex + 1;
        });
      }, 3000);

      return () => clearInterval(interval);
    }
  }, [isPaused, maxIndex]);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? maxIndex : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex >= maxIndex ? 0 : prevIndex + 1
    );
  };

  return (
    <section className="team-members-section pt-100 pb-70">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-12">
            <div className="team-title-box">
              <h2>Our Iron Like Strong <span>Team Members</span></h2>
              <div className="cta-btn">
                <span className="primary-btn">Team Members</span>
              </div>
            </div>
          </div>
          
          <div className="col-lg-9 col-md-12">
            <div 
              className="team-slider-wrapper"
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
            >
              <div 
                className="team-slider-track"
                style={{ 
                  transform: `translateX(-${currentIndex * (100 / itemsPerView)}%)` 
                }}
              >
                {teamMembers.map((member) => (
                  <div key={member.id} className="team-member-card">
                    <div className="member-image">
                      <img src={member.image} alt={member.name} />
                      <div className="member-overlay">
                        <div className="member-info">
                          <h4>{member.name}</h4>
                          <span>{member.position}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <button 
                className="team-nav-btn prev-btn" 
                onClick={goToPrevious}
                aria-label="Previous member"
              >
                <i className="fas fa-chevron-left"></i>
              </button>
              <button 
                className="team-nav-btn next-btn" 
                onClick={goToNext}
                aria-label="Next member"
              >
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamMembers;
